import { IconShare2 } from "@tabler/icons-react";
import PopUp, { closeEveryModal, openModal } from "./PopUp.tsx";

type ShareButtonProps = {
  buttonTitle?: string;
  url: string;
  title: string;
  text?: string;
};
const ID_MODAL_SHARE = "share-pop-up";
const ShareButton = ({
  buttonTitle = "Teilen",
  url,
  title,
  text,
}: ShareButtonProps) => {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url,
        });
      } catch (err) {
        if (err instanceof Error && err.name !== "AbortError") {
          console.error(err);
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        openModal(ID_MODAL_SHARE);
      } catch {
        console.error("Clipboard not available");
      }
    }
  };

  return (
    <>
      <PopUp id={ID_MODAL_SHARE} title={"Link kopiert"}>
        <div className="flex justify-center">
          <button onClick={closeEveryModal} className="btn btn-success">
            Fertig
          </button>
        </div>
      </PopUp>
      <button className="btn rounded-full" onClick={handleShare}>
        <IconShare2 /> {buttonTitle}
      </button>
    </>
  );
};

export default ShareButton;
